// extracted by mini-css-extract-plugin
export default {"container":"ServerError_container__AiFWB","icon":"ServerError_icon__iGJVq","messageWrapper":"ServerError_messageWrapper__c6DNR","message":"ServerError_message__VTlYG"};